// Browser-native SHA-256 helper.
// Node's `crypto` module is externalized by Vite in the browser, so we use the
// Web Crypto API instead. Requires a secure context (https or localhost).
export async function sha256Hex (input) {
  const data = new TextEncoder().encode(input)
  const buffer = await window.crypto.subtle.digest('SHA-256', data)
  return Array.from(new Uint8Array(buffer))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('')
}
